export const lang = {
    //公共
    document_title:'CAR index',
    common_confirm:'Confirm',
    common_confirm_pay:'Confirm',
    common_no_data:'No data detected',
    common_no_data_short:'None',
    common_msg_dialog_title:'Tips',
    common_msg_login_first:'please login first', // to confirm
    common_msg_not_allow_access_first:'The relevant permissions have not been activated, please contact',
    //首页
    common_global_tip_title:'Tips',
    common_global_tip_confirm_known:'Noticed',
    common_global_tip_confirm_ok:'ok',
    //顶部
    common_header_lang: "中文",
    common_header_login: "Login",
    common_header_quit: "Click to log out",
    common_header_ret_home: "Click to back home",
    common_header_ret: "back",
    common_header_login_prompt: "Login first for better function use",
    common_header_remain_num: "Residual number",
    common_header_pay: "Donation",
    common_header_exit: "Exit",

    //底部
    common_contact:'Contact us',
    common_email:'Email address:',
    common_phone:'Phone number:',
    common_links_title:'Links',

    //登录注册
    //公共
    common_loginbox_input_email:'Email address',
    common_loginbox_input_pass:'Password',
    common_loginbox_link_login_wechat:'微信登录',
    common_loginbox_link_reg:'Sign up',
    common_loginbox_link_find_pass:'Forgot password?',
    common_loginbox_link_login:'Log in',
    //登录
    common_loginbox_login_title:'Sign in',
    common_loginbox_login:'Sign in',
    //注册
    common_loginbox_reg_title:'Sign up by Email',
    common_loginbox_send_code:'Get code',
    common_loginbox_input_code:'Security code',
    common_loginbox_reg:'Sign up',
    //找回密码
    common_loginbox_reset_title:'Reset password',
    common_loginbox_input_new_pass:'New password',
    //错误提示
    common_loginbox_err_email:'Invalid Email address! Please try again.',
    common_loginbox_err_pass:'Invalid password! Your password must contain at least 6 characters.',
    common_loginbox_err_code:'Invalid code. The security code must contain 4 characters.',
    //消息提示
    common_loginbox_msg_login_succ:'Login successful',
    common_loginbox_msg_login_fail:'Login error. Try again.',
    common_loginbox_msg_send_limit:'Too many operations. Try again later.',
    common_loginbox_msg_reg_succ:'Successfully. Await approval. An email with login details will be sent upon approval.',
    common_loginbox_msg_reset_succ:'Password reset successful.',
    common_loginbox_msg_reset_succ_login_fail:'Password reset successfully.  Auto-login failed, please try again manually.',
    common_loginbox_msg_reset_fail:'Password reset failed.',
    common_loginbox_msg_send_email_fail:'Sending failed.',
    common_loginbox_msg_send_email_succ:'Sent.',
    common_loginbox_msg_code_err:'Invalid security code. Four failed attempts, one attempt left.',
    common_loginbox_msg_code_err_no_num:'Incorrect security code.',
    common_loginbox_msg_login_gt_limit:'You have exceeded the maximum number of attempts for this action. Try again later.',
    common_loginbox_msg_login_user_in_black_list:'Your account has been locked.',
    common_loginbox_msg_login_ip_in_black_list:'Your IP has been locked.',
    common_loginbox_msg_user_pass_err:'Username/password is incorrect. Three more attempts left.',
    common_loginbox_msg_user_not_exist:'There is no user registered with that Email address. Check your Email address and try again later.',
    common_loginbox_msg_user_has_exist:'The account already exists. Please log in.',
    common_loginbox_msg_reg_fail:'Registration failed. Try again.',
    common_loginbox_msg_logout_succ:'Log out successful',
    //邮箱验证码
    common_email_titile:'Security code sent by JCar',
    common_email_content:'Your security code is {1}. The code will expire in 5 mins, please enter the code quickly for successful registration',

    pagination: {
        goto: 'Go to',
        pagesize: '/page',
        total_prefix: 'Total ',
        total_postfix:'',
        pageClassifier: ''
    },

    article_pub_date:"Publication Date",
    article_article_type:"Document Type",
    article_cited_num:"Citation Count",
    article_keyword:"Keywords",
    article_author:"Author",
    article_click_middle_author:"Click to Expand Middle Author",
    article_journal:"Journal",
    article_unpublish:"Unpublished",
    article_cas:"CAS ",
    article_cas_postfix:"",
    article_warning:"Warning",
    article_fisrt_collect:"First Inclusion",
    article_collect_time:"Collection Time",
    article_summary:"Abstract",
    article_expand_summary:"Expand Abstract",
    article_contraction_summary:"Contraction Abstract",
    article_zh_summary:"Chinese Abstract",
    article_en_summary:"English Abstract",
    article_summary_translating:"Translating Abstract…",
    article_click_retranslate:"Incorrect translation? Click to retranslate",
    article_reason:"Reason",

    valurev_conference_title:"Opening Speech",
    valurev_conference_p1:"Distinguished reviewers, esteemed academic colleagues, ladies and gentlemen:",
    valurev_conference_p2:"Hello everyone!",
    valurev_conference_p3:"In November and December 2026, we will gather in Suzhou, a city where ancient culture and modern vitality blend beautifully, to witness the opening of a new chapter for the global academic community. On behalf of ValuRev and all our partner publishers, and in my capacity as the conference chair, I extend my warmest welcome and sincerest gratitude to all of you for joining us!",
    valurev_conference_p4:"We are in an era of rapid knowledge iteration and abundant innovation. Within this grand landscape, academic peer review serves as a cornerstone, quietly supporting the construction of our knowledge edifice and safeguarding the quality and integrity of research outcomes. As reviewers, you are the indispensable guardians and guides of this system. With your exceptional expertise, rigorous approach, and selfless dedication, you discern genuine knowledge amidst a sea of manuscripts, guiding the advancement of research. You are the unsung heroes who propel the continuous expansion of the boundaries of human understanding.",
    valurev_conference_p5:"It is precisely to honor this crucial contribution and to further strengthen the ecosystem of academic exchange that ValuRev, together with our global publishing partners, has initiated and established the 'ValuRev Annual Reviewer Conference.' The conference is rich in content, including but not limited to the following:",
    valurev_conference_p6:"Gathering together: Allowing the reviewers, who usually work diligently behind the scenes, and journal editors to meet face-to-face, exchange ideas, and build consensus;",
    valurev_conference_p7:"Recruiting talent: Through on-site editorial board recruitment, reviewers can get more deeply involved in journal development and make an impact;",
    valurev_conference_p8:"Empowering and enhancing: Through professional reviewer training sessions, share evaluation insights to improve the efficiency and quality of review work;",
    valurev_conference_p9:"Celebrating achievements: The prestigious 'ValuRev Annual Reviewer' awards will be ceremoniously presented, honoring 20 reviewers each year who have made extraordinary contributions, with accolades and prizes.",
    valurev_conference_p10:"Choosing to host the inaugural conference in Suzhou, a city that combines classical heritage with an open spirit, is profoundly symbolic. We hope that the gentle charm of this place will nurture deep exchanges and that its timeless wisdom will inspire future collaborations.",
    valurev_conference_p11:"At this moment, we are not just launching a conference; we are planting a seed of hope. We aspire to, through years of effort, establish this conference as a prestigious platform that connects scholars worldwide, inspires excellence in review, and fosters academic prosperity and scientific communication.",
    valurev_conference_p12:"Finally, I wish the inaugural ValuRev Annual Reviewer Conference great success! May everyone have a fulfilling and enjoyable time in Suzhou!",
    valurev_conference_p13:"Thank you all!",
    valurev_conference_p14:"Conference Chair:",

    valurev_org_reg_01:"Institution",
    valurev_org_reg_02:"(If no name is matched, please enter it directly.)",
    valurev_org_reg_03:"En Name",
    valurev_org_reg_04:"Zh Name",
    valurev_org_reg_05:"Publication",
    // valurev_org_reg_06:"BRID",
    valurev_org_reg_07:"Email",
    valurev_org_reg_08:"Send Code",
    valurev_org_reg_09:"Confirm",
    valurev_org_reg_10:"Submission successful. Please wait for confirmation from your unit's administrator. The activation of your ValuRev account will be notified via email.",
    valurev_org_reg_11:"Back",

    valurev_apc_01:"Introduction to APC Discount Benefits",
    valurev_apc_02:"An APC discount refers to the fee reduction offered by a publisher when a reviewer completes a peer review within 14 days as required and meets the specified standards. This discount is applied to the Article Processing Charge (APC) when the reviewer submits a paper to the journals of the same publisher and it is accepted for publication. The discount rates vary across different publishers and journals, and whether discounts can be accumulated also differs. ",
    valurev_apc_03:"<b>Cumulative discounts</b> means that if a reviewer assists a publisher by reviewing five manuscripts, and receives a 20% APC discount for each review, then when the reviewer submits to a participating journal, the APC is waived 100% (20% x 5).",
    valurev_apc_04:" per"
}
